import { apiRequest, ApiResponse } from '../request'
import type { ChatFilters } from '@/components/atendimento/chat-filters/chat-filters'

/**
 * Filtro da lista de atendimentos salvo com nome pelo usuário.
 *
 * `filters` é o mesmo objeto que vai na query da listagem. Vem do backend como JSON
 * livre: um preset salvo antes de um campo novo existir continua válido, e o que a
 * tela não reconhece é ignorado.
 */
export interface ChatFilterPreset {
    id: number
    name: string
    filters: ChatFilters
    sortOrder: number
    createdAt: string
    updatedAt: string
}

export async function getChatFilterPresets(): Promise<ApiResponse<ChatFilterPreset[]>> {
    return apiRequest<ChatFilterPreset[]>('chat-filter-presets', {}, 'get')
}

export async function createChatFilterPreset(data: {
    name: string
    filters: ChatFilters
    sortOrder?: number
}): Promise<ApiResponse<ChatFilterPreset>> {
    return apiRequest<ChatFilterPreset>('chat-filter-presets', { data }, 'post')
}

export async function updateChatFilterPreset(
    id: number,
    data: { name?: string; filters?: ChatFilters; sortOrder?: number },
): Promise<ApiResponse<ChatFilterPreset>> {
    return apiRequest<ChatFilterPreset>(`chat-filter-presets/${id}`, { data }, 'patch')
}

export async function deleteChatFilterPreset(id: number): Promise<ApiResponse<{ id: number }>> {
    return apiRequest<{ id: number }>(`chat-filter-presets/${id}`, {}, 'delete')
}

export async function reorderChatFilterPresets(
    ids: number[],
): Promise<ApiResponse<ChatFilterPreset[]>> {
    return apiRequest<ChatFilterPreset[]>(
        'chat-filter-presets/reorder',
        { data: { ids } },
        'patch',
    )
}
